<nz-card *ngIf="!downloadingPdf">

    <div class="row heading_div m-b-30">
        <div class="col-lg-3 col-sm-3">
            <h4>{{(routeData.name).replaceAll('-' , ' ')}}</h4>
        </div>
        <div class="col-lg-9 col-sm-9 db_access_column">
            <nz-input-group *ngIf="routeData.name == 'shipment'" class="search_box" [nzSuffix]="prefixTemplate">
                <input [(ngModel)]="localSearch" autocomplete="off" type="text" nz-input placeholder="search here..">
            </nz-input-group>
            <nz-select [(ngModel)]="DbAccess" [ngModelOptions]="{standalone: true}" (ngModelChange)="DbAccessChange()"
                class="" nzPlaceHolder="Select Payment Terms" required>
                <nz-option *ngFor="let item of userData.dbAccess"
                    [nzLabel]="item.dbDetails.dbName + ' - ' + item.companyDetails.bpName"
                    [nzValue]="item.dbDetails.dbCode + '~' + item.companyDetails.bpCode"></nz-option>
            </nz-select>
            <img *ngIf="routeData.name != 'info-enquiry'" (click)="exportToExcel()" class="excel_image"
                src="../../../assets/images/logo/microsoft-excel.svg" alt="excel">
        </div>
        <div class="row search_row">
            <div class="col-lg-6 search_column mt-3">
                <nz-input-group *ngIf="routeData.name != 'shipment'" class="search_box" [nzSuffix]="prefixTemplate">
                    <input [(ngModel)]="localSearch" autocomplete="off" type="text" nz-input
                        placeholder="search here..">
                </nz-input-group>
            </div>
            <div *ngIf="routeData.name == 'shipment'" class="col-lg-8 col-sm-8 search_column col-12 mt-3">
                <nz-input-group class="search_box" [nzSuffix]="apiSearchTemplate">
                    <input [(ngModel)]="searchPO" (keyup)="inputKeyUp('po')" autocomplete="off" type="text" nz-input
                        placeholder="search by PO Number..">
                </nz-input-group>
                <nz-input-group class="search_box" [nzSuffix]="apiSearchTemplate">
                    <input [(ngModel)]="searchItem" (keyup)="inputKeyUp('items')" autocomplete="off" type="text"
                        nz-input placeholder="search by item code..">
                </nz-input-group>

                <button (click)="searchRecords()" class="login-form-button">search</button>
                <!-- <nz-select [(ngModel)]="searchType" class="" nzPlaceHolder="select search type" required>
                    <nz-option [nzLabel]="'PO Number'" [nzValue]="'PONumber'"></nz-option>
                    <nz-option [nzLabel]="'Item Code'" [nzValue]="'ItemCode'"></nz-option>
                </nz-select> -->
            </div>
            <div *ngIf="routeData.name == 'shipment'" class="col-lg-2 col-12 text-right mt-3">
                <button style="margin-top: 2px;" nz-button nzType="primary" (click)="showDrawer()"
                    class="login-form-button">Update</button>
            </div>
            <ng-template #apiSearchTemplate>
                <i nz-icon (click)="searchRecords()" nzType="search" class="opacity-05 search_btn"></i>
            </ng-template>
        </div>

        <ng-template #prefixTemplate>
            <i nz-icon nzType="search" class="opacity-05"></i>
        </ng-template>
    </div>

    <nz-table *ngIf="routeData.name != 'info-enquiry'" #reportListTable nzBordered [nzData]="reportList"
        [nzScroll]="{x: tableWidth , y: tableHeight }" [nzShowPagination]="false" [nzPageSize]="1000"
        (nzQueryParams)="onPageChange($event)">
        <thead>
            <tr>
                <th *ngFor="let column of orderColumn" [nzWidth]="column.width" [nzSortFn]="column.compare">{{
                    column.title }}</th>
            </tr>
        </thead>
        <tbody>
            <tr id="reportTable" *ngFor="let value of reportListTable.data | filter : localSearch;  let i=index"
                [ngClass]="{'errorRow' : i == errorIndex}">
                <td>{{i+1}}</td>
                <td *ngIf="routeData.name != 'payments' && routeData.name !='shipment'">{{value.docNum}}</td>
                <td *ngIf="routeData.name != 'payments' && routeData.name !='shipment'">{{value.docStatus}}</td>
                <td *ngIf="routeData.name != 'payments' && routeData.name !='shipment'">
                    {{moment(value.docDate).format('DD-MM-YYYY')}}</td>
                <td *ngIf="routeData.name != 'payments' && routeData.name !='shipment'">
                    {{moment(value.docDueDate).format('DD-MM-YYYY')}}</td>
                <td *ngIf="routeData.name != 'payments' && routeData.name !='shipment'">{{value.numAtCard}}</td>
                <td *ngIf="routeData.name != 'payments' && routeData.name !='shipment'">{{(value.total).toFixed(2)}}
                </td>
                <td *ngIf="routeData.name != 'payments' && routeData.name !='shipment'">{{(value.vatSum).toFixed(2)}}
                </td>
                <td *ngIf="routeData.name != 'payments' && routeData.name !='shipment'">{{(value.docTotal).toFixed(2)}}
                </td>
                <td *ngIf="routeData.name != 'payments' && routeData.name !='shipment'">{{value.comments ?
                    value.comments : '-'}}</td>
                <!-- PAYMENTS TABLE DETAILS -->
                <td *ngIf="routeData.name == 'payments'">{{value.docNum}}</td>
                <td *ngIf="routeData.name == 'payments'">{{moment(value.docDate).format('DD-MM-YYYY')}}</td>
                <td *ngIf="routeData.name == 'payments'">{{value.cardCode}}</td>
                <td *ngIf="routeData.name == 'payments'">{{value.cardName}}</td>
                <td *ngIf="routeData.name == 'payments'">{{value.cashSum}}</td>
                <!-- PAYMENTS TABLE DETAILS -->
                <td *ngIf="routeData.name == 'shipment'">{{value.poDocNum}}</td>
                <td *ngIf="routeData.name == 'shipment'">{{moment(value.poDate).format('DD-MM-YYYY')}}</td>
                <td *ngIf="routeData.name == 'shipment'">{{moment(value.dueDate).format('DD-MM-YYYY')}}</td>
                <td *ngIf="routeData.name == 'shipment'">{{value.itemCode}}</td>
                <td *ngIf="routeData.name == 'shipment'">{{value.itemName}}</td>
                <td *ngIf="routeData.name == 'shipment'">{{value.price}}</td>
                <td *ngIf="routeData.name == 'shipment'">{{value.poQty}}</td>
                <td *ngIf="routeData.name == 'shipment'">{{value.openQty}}</td>
                <td *ngIf="routeData.name == 'shipment'">
                    <div class="add_quantity">
                        <input nz-input type="number" placeholder="Delivery Count" [(ngModel)]="value.deliveryCount"
                            (keyup)="countChange(i , value , $event)">
                        <a [ngClass]="{'disable_tag' : addedFields.indexOf(value.rowUniqueId) > -1}"
                            (click)="enterValue(value , i)" class="">Add</a>
                    </div>
                </td>
                <td *ngIf="routeData.name == 'shipment'">{{value.deliveryCount != undefined ? value.deliveryCount -
                    value.openQty : 0}} </td>

                <td *ngIf="routeData.name == 'shipment'">
                    <div class="add_quantity">
                        <input (keyup)="rejQTYchange(value , 'FR' , i)" nz-input type="number"
                            placeholder="FR Reject Qty" [(ngModel)]="value.FRRejQty">
                    </div>
                </td>
                <td *ngIf="routeData.name == 'shipment'">
                    <div class="add_quantity">
                        <input (keyup)="rejQTYchange(value, 'MR' , i)" nz-input type="number"
                            placeholder="MR Reject Qty" [(ngModel)]="value.MRRejQty">
                    </div>
                </td>

                <td *ngIf="routeData.name == 'shipment'">{{value.stockInTransit}}</td>
                <td *ngIf="routeData.name == 'shipment'">
                    <div class="add_quantity">
                        <input (keyup)="addRemark(value)" nz-input type="text" placeholder="Add remarks"
                            [(ngModel)]="value.remarks">
                    </div>
                </td>
            </tr>
        </tbody>
    </nz-table>

    <!-- INFO ENQUIRY FORM SECTION STARTS -->

    <div *ngIf="routeData.name == 'info-enquiry'" class="row justify-content-start ">
        <div class="col-lg-8 col-10">
            <form [formGroup]="enquiryForm" (ngSubmit)="sendEnquiry()" nzForm autocomplete="off">
                <nz-form-item>
                    <nz-form-label [nzSm]="6" nzRequired nzFor="Company Name">Remarks</nz-form-label>
                    <nz-form-control nzErrorTip="Please Enter Your Remarks!">
                        <nz-input-group>
                            <textarea formControlName="enquiryText" rows="4" nz-input
                                placeholder="Enter your Remarks here"></textarea>
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item class="text-center ml-5">
                    <nz-form-control>
                        <a><button [nzLoading]="loadEnquiry" type="submit" nz-button
                                nzType="primary">Submit</button></a>
                    </nz-form-control>
                </nz-form-item>
            </form>
        </div>
    </div>

    <ngx-spinner bdColor="#fff" size="medium" color="#00005b" type="line-scale-pulse-out-rapid" [fullScreen]="false">
    </ngx-spinner>
    <!-- INFO ENQUIRY FORM SECTION ENDS -->
</nz-card>

<!-- Drawer Component -->

<nz-drawer [nzWidth]="'60%'" [nzClosable]="false" [nzVisible]="visible" nzPlacement="right"
    nzTitle="Material Estimation " (nzOnClose)="close()">
    <ng-container *nzDrawerContent>

        <div class="mb-3">
            <div class="tm_style1">
                <nz-table class="preview_table" #addedFieldsTable [nzShowPagination]="false" [nzData]="grnData"
                    [nzScroll]="{ y: '300px' , x : '500px' }">
                    <thead>
                        <tr>
                            <th *ngFor="let column of estimationHeadings" [nzWidth]="column.width">{{ column.title }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of addedFieldsTable.data ;  let i=index">

                            <td>
                                <h6 class="">{{item?.POItemCode}}</h6>
                            </td>

                            <td>
                                <h6 class="">{{item?.POItemName}}</h6>
                            </td>

                            <td>
                                <h6 class="">{{item?.POQuantity}}</h6>
                            </td>

                            <td>
                                <h6 class="">{{item?.POUnitPrice}}</h6>
                            </td>

                            <td>
                                <h6 class="">₹ {{
                                    (item?.POQuantity * item?.POUnitPrice) | commaSeparator}}
                                </h6>
                            </td>
                        </tr>
                        <tr class="total_row">
                            <td> </td>
                            <td> </td>
                            <td> </td>

                            <td class="total_section">
                                <h6>SubTotal : </h6>
                                <h6>Tax Amount : </h6>
                                <h6>Net Amount : </h6>
                            </td>
                            <td class="total_section">
                                <span>₹ {{subTotal | commaSeparator}}</span><br>
                                <span>₹ {{taxTotal | commaSeparator}}</span><br>
                                <span>₹ {{netTotal | commaSeparator}}</span>
                            </td>
                        </tr>
                    </tbody>
                </nz-table>
                <!-- <div class="total_section text-right mt-3">
                    <h6>SubTotal : <span>₹ {{subTotal | commaSeparator}}</span></h6>
                    <h6>Tax Amount : <span>₹ {{taxTotal | commaSeparator}}</span></h6>
                    <h6>Net Amount : <span>₹ {{netTotal | commaSeparator}}</span></h6>
                </div> -->
            </div>
        </div>

        <div class="">
            <div class="upload_btn_div">
                <!-- <nz-form-label [nzSm]="6" [nzXs]="44" nzRequired>MTC Attachment</nz-form-label> -->
                <div class="upload_sec">
                    <label for='mtc_attachment' class="preview_sample">
                        <span nz-icon nzType="cloud-upload" nzTheme="outline"></span>
                        <p>MTC / QC Report Attachment</p>
                    </label>
                    <input class="upload_input" (change)="getDelOrdImageFile($event)" id="mtc_attachment" type="file">
                    <img *ngIf="deliveryOrderImage" class="preview_image"
                        [src]="docTypes.indexOf(MTCType) > -1 ? docLink : deliveryOrderImage" alt="">
                </div>

                <!-- <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Invoice Attachment</nz-form-label> -->
                <div class="upload_sec">
                    <label for='invoice_attachment' class="preview_sample">
                        <span nz-icon nzType="cloud-upload" nzTheme="outline"></span>
                        <p>Invoice Attachment</p>
                    </label>
                    <input class="upload_input" (change)="getInvoiceImageFile($event)" id="invoice_attachment"
                        type="file">
                    <img *ngIf="invoiceImage" class="preview_image"
                        [src]="docTypes.indexOf(invoiceType) > -1 ? docLink : invoiceImage" alt="">
                </div>

                <!-- <div class="upload_sec">
                    <label for='rq_report_attachment' class="preview_sample">
                        <span nz-icon nzType="cloud-upload" nzTheme="outline"></span>
                        <p>QC Report Attachment</p>
                    </label>
                    <input class="upload_input" (change)="getQCReportImage($event)" id="rq_report_attachment"
                        type="file">
                    <img *ngIf="QCReportImage" class="preview_image"
                        [src]="docTypes.indexOf(QCReportType) > -1 ? docLink : QCReportImage" alt="">
                </div> -->
            </div>

            <nz-form-item class="preview_group">
                <nz-form-control>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Supplier Invoice No</nz-form-label>
                    <input [(ngModel)]="invoiceNumber" autocomplete="off" type="text" nz-input
                        placeholder="Invoice Number">
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="preview_group">
                <nz-form-control>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Remarks</nz-form-label>
                    <input [(ngModel)]="remarks" autocomplete="off" type="text" nz-input placeholder="Remarks">
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="preview_group text-center mt-5">
                <nz-form-control>
                    <a><button (click)="reset()" class="reset_button" nz-button type="reset"
                            nzType="default">close</button></a>
                    <a style="padding-left: 20px;">
                        <button [nzLoading]="invoiceUpdating" (click)="addGRPO()" nz-button
                            nzType="primary">Submit</button></a>
                </nz-form-control>
            </nz-form-item>
        </div>
    </ng-container>
</nz-drawer>

<nz-card *ngIf="downloadingPdf">
    <div id="download_pdf" class="pdf_section">
        <div class="">
            <p>{{pdfData[0]}}</p>
            <p> {{pdfData[1]}}</p>
            <ngx-barcode [bc-value]="qrData[1]" [bc-display-value]="true"></ngx-barcode>
        </div>
    </div>
</nz-card>